const NavigationModes = {
    EARTH: 'EARTH',
    ORBIT: 'ORBIT',
    FLY_CONTROL: 'FLY_CONTROL',
} as const;

type NavigationMode = (typeof NavigationModes)[keyof typeof NavigationModes];

export class NavigationModeService {
    private navigationMode?: NavigationMode;
    private viewer: any;

    constructor() {
        this.navigationMode = NavigationModes.ORBIT;
        this.viewer = window.viewer;
    }

    setViewerControls(mode: NavigationMode) {
        switch (mode) {
            case NavigationModes.EARTH:
                this.viewer.setControls(this.viewer.earthControls);
                break;
            case NavigationModes.ORBIT:
                this.viewer.setControls(this.viewer.orbitControls);
                break;
            case NavigationModes.FLY_CONTROL:
                this.viewer.setControls(this.viewer.fpControls);
                this.viewer.fpControls.lockElevation = false;
                break;
            default:
                this.viewer.setControls(this.viewer.orbitControls);
        }
    }

    setNavigationMode(mode: NavigationMode) {
        this.navigationMode = mode;
        this.setViewerControls(mode);
    }

    getNavigationMode() {
        return this.navigationMode;
    }
}
